import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { createCustomer } from 'store/customer/thunks/createCustomer.thunk';
import { updateCustomer } from 'store/customer/thunks/updateCustomer.thunk';
import { deleteProject } from 'store/projects/thunks/deleteProject.thunk';
import CustomerDialogLayout from './CustomerDialogLayout';

function CustomerDialog(props) {
  const dispatch = useDispatch();

  const create = props.type === 'create';

  const customer = props.customer;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log('CustomerDialog customer', customer);
  }, [customer]);

  const { enqueueSnackbar } = useSnackbar();

  const onCreate = async (customerData) => {
    try {
      console.log('Creating customer', customerData);
      setLoading(true);

      const customerResponse = await dispatch(
        createCustomer(customerData)
      ).then((response) => response);

      if (customerResponse.payload) {
        enqueueSnackbar('Asiakas lisätty', { variant: 'success' });
        props.onClose();
      }
    } catch (e) {
      console.log('CREATION FAILED:', e);
      enqueueSnackbar('Asiakkaan luonti epäonnistui', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const onUpdate = async (customerData) => {
    try {
      console.log('Updating customer', customerData);
      setLoading(true);

      const customerResponse = await dispatch(
        updateCustomer(customerData)
      ).then((response) => response);

      if (customerResponse.payload) {
        enqueueSnackbar('Asiakas päivitetty', { variant: 'success' });
        props.onClose();
      }
    } catch (e) {
      console.log('CREATION FAILED:', e);
      enqueueSnackbar('Asiakkaan päivitys epäonnistui', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const onDelete = async (project) => {
    try {
      console.log('Deleting project', project);
      setLoading(true);

      const projectId = project.id;

      // Update project
      const projectResponse = await dispatch(deleteProject(projectId)).then(
        (response) => response
      );
      console.log('DELETION RESPONSE:', projectResponse);
      console.log('DELETION PAYLOAD:', projectResponse.payload);

      if (projectResponse.payload) {
        // Show success message and close dialog
        enqueueSnackbar('Projekti poistettu', { variant: 'success' });
        props.onClose();
      }
    } catch (e) {
      console.log('DELETION FAILED:', e);
      enqueueSnackbar('Projektin poistaminen epäonnistui', {
        variant: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomerDialogLayout
      onClose={props.onClose}
      loading={loading}
      open={props.open}
      customer={create ? {} : customer}
      type={props.type}
      onCreate={onCreate}
      onUpdate={onUpdate}
      onDelete={onDelete}
    />
  );
}

CustomerDialog.defaultProps = {
  type: 'create',
  customer: undefined,
};

CustomerDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['create', 'edit']).isRequired,
  customer: PropTypes.object,
};

export default CustomerDialog;
